function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import _ from "lodash";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import DeleteRowRenderer from "./delete-row-renderer";

var ReactFormulaAgGridTable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReactFormulaAgGridTable, _React$Component);

  function ReactFormulaAgGridTable() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFormulaDisplayed: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleGridReady", function (params) {
      _this.gridApi = params.api;
      _this.gridColumnApi = params.columnApi;
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowChange", function (event) {
      var onChange = _this.props.onChange;
      onChange && onChange(_this.props.value);

      _this.props.builder.withDataObjects(_this.props.value);

      _this.refreshAll();
    });

    _defineProperty(_assertThisInitialized(_this), "handleCellValueChange", function (event) {
      var onChange = _this.props.onChange;
      onChange && onChange(_this.props.value);

      _this.props.builder.withDataObjects(_this.props.value);

      _this.refreshAll();
    });

    _defineProperty(_assertThisInitialized(_this), "handleDeleteRow", function (event, rowIndex) {
      var trimmedData = _.reject(_this.props.value, function (item, index) {
        return index === rowIndex;
      });

      _this.props.onChange(trimmedData);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddRow", function () {
      _this.props.onChange([].concat(_this.props.value, [{}]));
    });

    _defineProperty(_assertThisInitialized(_this), "refreshAll", function () {
      var params = {
        force: true
      };

      _this.gridApi.refreshCells(params);
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleDisplayFormula", function (event, value) {
      _this.setState({
        isFormulaDisplayed: event.target.checked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "cellRenderer", function (_ref) {
      var header = _ref.header,
          val = _objectWithoutPropertiesLoose(_ref, ["header"]);

      var computedValue = _this.props.builder.getComputedValue(header.header, val.rowIndex);

      var originalValue = _this.props.builder.getValue(header.header, val.rowIndex);

      var value = _this.state.isFormulaDisplayed ? originalValue : computedValue;

      if (_.isObject(value)) {
        return value.value;
      }

      return value;
    });

    return _this;
  }

  var _proto = ReactFormulaAgGridTable.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.gridApi) {
      this.refreshAll();
    }
  };

  _proto.createColumnDefs = function createColumnDefs(headers) {
    var columnDefs = _.map(headers, function (header) {
      var additionalProps = header.readOnly ? {
        cellRenderer: "cellRenderer",
        cellRendererParams: {
          header: header
        }
      } : {};
      return _extends({
        field: header.header,
        editable: !!!header.readOnly
      }, additionalProps);
    });

    var defaultDefs = [{
      cellRenderer: "deleteRowRenderer",
      cellRendererParams: {
        onClick: this.handleDeleteRow,
        confirmRemove: this.props.confirmRemove
      },
      width: 100
    }];
    var allColumnDefs = [].concat(columnDefs);
    if (this.props.removable) allColumnDefs.push.apply(allColumnDefs, defaultDefs);
    return allColumnDefs;
  };

  _proto.resizeColumns = function resizeColumns(params) {
    params.api.sizeColumnsToFit();
  };

  _proto.renderSwitch = function renderSwitch() {
    var isFormulaDisplayed = this.state.isFormulaDisplayed;
    return /*#__PURE__*/React.createElement(Form.Check, {
      type: "checkbox",
      label: "Check me out",
      className: "custom-control custom-switch d-print-none"
    }, /*#__PURE__*/React.createElement(Form.Check.Input, {
      onChange: this.handleToggleDisplayFormula,
      className: "custom-control-input",
      type: "checkbox",
      id: "customSwitch1",
      checked: isFormulaDisplayed
    }), /*#__PURE__*/React.createElement(Form.Check.Label, {
      className: "custom-control-label",
      htmlFor: "customSwitch1"
    }, "Show Formula"));
  };

  _proto.renderMenuItems = function renderMenuItems() {
    return /*#__PURE__*/React.createElement(Row, {
      className: "align-items-center justify-content-md-end d-print-none"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: "auto"
    }, this.renderSwitch()), /*#__PURE__*/React.createElement(Col, {
      sm: "auto"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: this.handleAddRow,
      variant: "link",
      size: "sm"
    }, "Add Item")));
  };

  _proto.render = function render() {
    var columnDefs = this.createColumnDefs(this.props.headers);
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "ag-theme-balham",
      style: {
        height: this.props.height || 400,
        width: this.props.width || "100%"
      }
    }, /*#__PURE__*/React.createElement(AgGridReact, {
      groupSelectsChildren: true,
      columnDefs: columnDefs,
      rowData: this.props.value,
      gridOptions: {
        onRowValueChanged: this.handleRowChange,
        onCellValueChanged: this.handleCellValueChange,
        components: {
          "cellRenderer": this.cellRenderer
        },
        frameworkComponents: {
          "deleteRowRenderer": DeleteRowRenderer
        }
      },
      onFirstDataRendered: this.resizeColumns,
      onGridReady: this.handleGridReady
    }, /*#__PURE__*/React.createElement(AgGridColumn, {
      field: "$delete"
    }), _.map(this.props.headers, function (header, i) {
      return /*#__PURE__*/React.createElement(AgGridColumn, {
        key: i,
        field: header.header
      });
    })))), this.renderMenuItems());
  };

  return ReactFormulaAgGridTable;
}(React.Component);

export default ReactFormulaAgGridTable;